export enum CouponType {
    FLAT = 'FLAT',
    PERCENT = 'PERCENT',
}
